import { Box, Flex } from 'theme-ui'
import { toast, ToastContent, ToastOptions } from 'react-toastify'
import {
  FaCheckCircle,
  FaInfoCircle,
  FaExclamationCircle,
  FaTimesCircle,
} from 'react-icons/fa'
import { IconType } from 'react-icons/lib/cjs'
import { get } from 'lodash'
import colors from '../theme/colors'

const notify = (
  message: ToastContent,
  type: ToastOptions['type'] = 'default',
  options?: ToastOptions,
  icon?: IconType,
  style?: any,
  title?: string
) => {
  const toastContent = (
    <Flex data-cy="Notif-message">
      <Box sx={{ flex: 1 }}>{icon ? icon({ size: 23 }) : null}</Box>
      <Box sx={{ flex: 7 }}>
        <div data-cy="Notif-title" className="mb-1">
          {title}
        </div>
        <div data-cy="Notif-message">{composeMessage(message)}</div>
      </Box>
    </Flex>
  )

  toast(toastContent, {
    ...options,
    type,
    style: { ...style, top: '80px' },
    icon: false,
  })
}

export const notifySuccess = (
  message: ToastContent = 'Success',
  options?: ToastOptions
) => {
  notify(
    message,
    'success',
    options,
    FaCheckCircle,
    {
      style: {
        borderColor: colors.primary,
        borderTopWidth: '2px',
        borderBottomWidth: '2px',
        borderRightWidth: '2px',
        borderLeftWidth: '5px',
        borderStyle: 'solid',
        color: colors.primary,
        backgroundColor: colors.background,
      },
    },
    ''
  )
}

export const notifyReject = (message: ToastContent, options?: ToastOptions) => {
  notify(message, 'error', options, FaExclamationCircle)
}

export const notifyError = (message: ToastContent, options?: ToastOptions) => {
  notify(
    message,
    'error',
    options,
    FaTimesCircle,
    {
      style: {
        borderColor: colors.error,
        borderTopWidth: '2px',
        borderBottomWidth: '2px',
        borderRightWidth: '2px',
        borderLeftWidth: '5px',
        borderStyle: 'solid',
        color: colors.error,
        backgroundColor: colors.background,
      },
    },
    ''
  )
}

export const notifyInfo = (message: ToastContent, options?: ToastOptions) => {
  notify(message, 'default', options, FaInfoCircle)
}

function composeMessage(messages: any) {
  if (messages instanceof Array) {
    if (messages.length > 1) {
      return (
        <ul>
          {messages.map((message, index) => {
            return <li key={index}>{message}</li>
          })}
        </ul>
      )
    } else {
      return messages.join('')
    }
  }
  return messages
}

export const notifyErrorAPI = (error) => {
  const messages = get(error, 'response.data.message', [])

  return notifyError(
    messages.length ? messages : 'Oops, something went wrong!',
    {
      autoClose: 5000,
    }
  )
}
